import React from 'react';
import { Box, Stack, TextField, Checkbox, FormControlLabel, Button, Typography, Paper, MenuItem } from '@mui/material';
import { createUser, getUser, updateUser } from '../api/users';
import { useNavigate, useParams } from 'react-router-dom';

const UserFormPage: React.FC = () => {
  const navigate = useNavigate();
  const params = useParams();
  const isEdit = Boolean(params.id);
  const [email, setEmail] = React.useState('');
  const [username, setUsername] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [isActive, setIsActive] = React.useState(true);
  const [role, setRole] = React.useState<'user' | 'admin'>('user');
  const [nextcloudUsername, setNextcloudUsername] = React.useState('');
  const [nextcloudPassword, setNextcloudPassword] = React.useState('');
  const [nextcloudFolder, setNextcloudFolder] = React.useState('');
  const [nifColumn, setNifColumn] = React.useState('NIF');
  const [linkExpirationDays, setLinkExpirationDays] = React.useState<number | ''>('');
  const [nameColumn, setNameColumn] = React.useState('Grantor Name');
  const [emailColumn, setEmailColumn] = React.useState('Email');
  const [phoneColumn, setPhoneColumn] = React.useState('Teléfono');

  React.useEffect(() => {
    const load = async () => {
      if (isEdit && params.id) {
        const data = await getUser(Number(params.id));
        setEmail(data.email);
        setUsername(data.username);
        setIsActive(data.isActive);
        // @ts-ignore: role puede venir del backend
        if ((data as any).role) setRole((data as any).role);
        // @ts-ignore
        if ((data as any).nextcloudUsername) setNextcloudUsername((data as any).nextcloudUsername);
        // @ts-ignore
        if ((data as any).nextcloudFolder) setNextcloudFolder((data as any).nextcloudFolder);
        if ((data as any).nifColumn) setNifColumn((data as any).nifColumn);
        if ((data as any).linkExpirationDays !== undefined && (data as any).linkExpirationDays !== null) setLinkExpirationDays((data as any).linkExpirationDays);
        if ((data as any).nameColumn) setNameColumn((data as any).nameColumn);
        if ((data as any).emailColumn) setEmailColumn((data as any).emailColumn);
        if ((data as any).phoneColumn) setPhoneColumn((data as any).phoneColumn);
      }
    };
    load();
  }, [isEdit, params.id]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isEdit && params.id) {
      await updateUser(Number(params.id), { email, username, isActive, password: password || undefined, role, nextcloudUsername: nextcloudUsername || undefined, nextcloudPassword: nextcloudPassword || undefined, nextcloudFolder: nextcloudFolder || undefined, nifColumn: nifColumn || undefined, linkExpirationDays: linkExpirationDays === '' ? undefined : Number(linkExpirationDays), nameColumn: nameColumn || undefined, emailColumn: emailColumn || undefined, phoneColumn: phoneColumn || undefined });
    } else {
      await createUser({ email, username, password, isActive, role, nextcloudUsername: nextcloudUsername || undefined, nextcloudPassword: nextcloudPassword || undefined, nextcloudFolder: nextcloudFolder || undefined, nifColumn: nifColumn || undefined, linkExpirationDays: linkExpirationDays === '' ? undefined : Number(linkExpirationDays), nameColumn: nameColumn || undefined, emailColumn: emailColumn || undefined, phoneColumn: phoneColumn || undefined });
    }
    navigate('/users');
  };

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
        {isEdit ? 'Editar Usuario' : 'Nuevo Usuario'}
      </Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <Stack spacing={2}>
          <TextField label="Email" value={email} onChange={e => setEmail(e.target.value)} required type="email" />
          <TextField label="Usuario" value={username} onChange={e => setUsername(e.target.value)} required />
          <TextField label="Contraseña" value={password} onChange={e => setPassword(e.target.value)} type="password" required={!isEdit} helperText={isEdit ? 'Dejar vacío para no cambiar' : ''} />
          <FormControlLabel control={<Checkbox checked={isActive} onChange={e => setIsActive(e.target.checked)} />} label="Activo" />
          <TextField select label="Rol" value={role} onChange={e => setRole(e.target.value as any)}>
            <MenuItem value="user">Usuario</MenuItem>
            <MenuItem value="admin">Administrador</MenuItem>
          </TextField>
          <TextField label="Nextcloud User" value={nextcloudUsername} onChange={e => setNextcloudUsername(e.target.value)} />
          <TextField label="Nextcloud Password" type="password" value={nextcloudPassword} onChange={e => setNextcloudPassword(e.target.value)} />
          <TextField label="Nextcloud Folder" value={nextcloudFolder} onChange={e => setNextcloudFolder(e.target.value)} helperText="Nombre de la carpeta base donde se crearán las subcarpetas" />
          <TextField label="Columna NIF (Excel)" value={nifColumn} onChange={e => setNifColumn(e.target.value)} helperText="Nombre exacto de la columna del Excel que contiene el NIF" />
          <TextField label="Días expiración enlace" type="number" value={linkExpirationDays} onChange={e => setLinkExpirationDays(e.target.value === '' ? '' : Number(e.target.value))} helperText="0 para sin expiración" />
          <TextField label="Columna Nombre (Excel)" value={nameColumn} onChange={e => setNameColumn(e.target.value)} />
          <TextField label="Columna Email (Excel)" value={emailColumn} onChange={e => setEmailColumn(e.target.value)} />
          <TextField label="Columna Teléfono (Excel)" value={phoneColumn} onChange={e => setPhoneColumn(e.target.value)} />
          <Stack direction="row" spacing={2}>
            <Button type="submit" variant="contained">Guardar</Button>
            <Button variant="outlined" onClick={() => navigate('/users')}>Cancelar</Button>
          </Stack>
        </Stack>
      </Box>
    </Paper>
  );
};

export default UserFormPage;


